/**
 * AI 生文- 新会话
 * @returns
 */

import { Box, Flex, useToast } from "@chakra-ui/react";
import { selectUser } from "@/reducer/userslice";

import { useEffect, useRef, useState } from "react";
import ChatTextInput from "@/components/writingComponent/InputComponent3";
import AiSessionItem2 from "@/components/writingComponent/aiSessionItem2";
import HumanSessionItem2 from "@/components/writingComponent/humanSessionItem2";
import { deleteChatMsg, selectCurrentChatList, selectCurrentTopic, setChat } from "@/reducer/chatSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import useSSE from "@/components/hook/useSSE";
import { addChat, sendMsg, sendMsg2 } from "@/services/api/thunks/chat";
import { ChatContent, ChatTopic } from "@/types/writing";
import { newId } from "@/utils/utils";

const NewMeeting = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const user = useAppSelector(selectUser);
  const currentTopic = useAppSelector(selectCurrentTopic);
  const sessionId = currentTopic.id;
  const currentChatList = useAppSelector(selectCurrentChatList);
  // const { sseData, sseReadyState, closeSource, reconnectSSE } = useSSE(`/api/v4/chats/connect/${newId()}?user_id=${user.id}`);
  const [files, setFiles] = useState<File[]>([]);
  const [text, setText] = useState("");
  const chatListRef = useRef<HTMLDivElement>(null)

  const [messages, setMessages] = useState({});
  useEffect(() => {
    // 创建 WebSocket 连接
    const hostname = window.location.hostname=="localhost"?"192.168.1.6:8065":window.location.hostname;
    const webSocket = new WebSocket(`//${hostname}/api/v4/ws?user_id=${user.id}`);

    webSocket.onopen = () => {
      console.log('WebSocket连接已建立');
      webSocket.send(JSON.stringify("topic"));
    };

    webSocket.onmessage = (event) => {
      setMessages({...JSON.parse(event.data)});
    };

    webSocket.onerror = (error) => {
      console.error('WebSocket错误:', error);
    };

    webSocket.onclose = () => {
      console.log('WebSocket连接已关闭');
    };
    // 清理函数，组件卸载时关闭 WebSocket 连接
    return () => {
      webSocket.close();
    };
  }, []);

  useEffect(() => {
    console.log('接收到的数据', messages)
    var res = messages as ChatContent;
    res = { ...res, once: true }
    dispatch(setChat(res))
  }, [messages])
  useEffect(() => {
    const current = chatListRef.current!
    //scrollHeight是页面的高度
    current.scrollTop = current.scrollHeight
  }, [currentChatList])

  const updateFile = (files: File[]) => {
    setFiles(files);
  };
  const updataInputValue = (chatMsg: ChatContent) => {
    dispatch(deleteChatMsg(chatMsg))
    dispatch(sendMsg2(chatMsg))
  };

  const updateValue = (text: string) => {
    setText(text)
  };

  const handleSubmit = async () => {
    if (!user) {
      toast({ title: "请登录系统", position: "top", status: "error", duration: 1000 });
      return;
    }

    if (!sessionId) {
      const action = await dispatch(addChat({ user_id: user.id, title: text, role: "" }));
      if (action.payload as ChatTopic) {
        const chat = action.payload as ChatTopic
        const id = newId()
        var data = {
          id,
          message: text,
          user_id: user.id,
          chat_id: chat.id
        };
        dispatch(setChat({ id: id, chat_id: chat.id, message: text, message_role: "user", user_id: user.id, parent_id: "0" } as ChatContent))
        dispatch(sendMsg(data))
      }
    } else {
      const id = newId()
      var data = {
        id,
        message: text,
        user_id: user.id,
        chat_id: sessionId
      };
      dispatch(setChat({ id: id, chat_id: sessionId, message: text, message_role: "user", user_id: user.id, parent_id: "0" } as ChatContent))
      dispatch(sendMsg(data))
    }
    setText('')
  };

  return (
    <>
      <Flex flexDirection="column" h="100%" maxW={"1028px"} m="0 auto">
        <Box flex={1} h="0" mt="50px" mb="50px">
          <Box h="100%" overflow={"auto"} pr="10px" ml="10px" mr="10px" ref={chatListRef}>
            {currentChatList && currentChatList.map((item, index) => {
              return (
                <Box key={index}>
                  {(item.message_role === "assistant" || item.message_role === "system") && (
                    <AiSessionItem2
                      sessionContent={item}
                      reAnswer={updataInputValue}
                    />
                  )}

                  {item.message_role === "user" && (
                    <HumanSessionItem2 sessionContent={item} />
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
        <Box mb="40px">
          <ChatTextInput
            text={text}
            updateValue={updateValue}
            handleSubmit={handleSubmit}
          />
        </Box>
      </Flex>
    </>
  );
};

export default NewMeeting;
